import styled from 'styled-components';
import { black, blue, boxShadow1 } from '../../../../utils/style/colors';
import { languageDirection } from '../../../../i18n';

export const InfoItem = styled.div`
  margin: 0.5rem 1rem;
  display: flex;
  align-items: center;
`;

export const InfoPart = styled('span')`
  color: ${black};
  margin: 0.5rem 0.5rem 0;
  @media only screen and (max-width: 600px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;
export const DownloadPart = styled('span')`
  margin: 0.5rem 0.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const SuperContainer = styled('div')`
  height: 100%;
  @media only screen and (max-width: 600px) {
  }
`;

interface InfoContainerProps {
  background?: string;
  active: boolean;
}
export const InfoContainerWrapper = styled('div')`
  max-height: 100%;
  direction: ${languageDirection()};
  float: ${languageDirection() === 'rtl' ? 'right' : 'left'};
`;
export const InfoContainer = styled('div')<InfoContainerProps>`
  ${(props) => `background-color: ${props.background || 'var(--exact-white)'};`}
  ${(props) =>
    `border: ${props.active ? `2px solid ${blue} ` : 'var(--exact-white)'};`}
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  @media only screen and (max-width: 600px) {
    flex-direction: row;
    justify-content: space-between;
  }
  padding: 0 !important;
  min-width: 0;

  box-shadow: ${boxShadow1};
  transition: box-shadow 0.25s;
  border-radius: 10px;
  margin-bottom: 10px;
  @media only screen and (max-width: 600px) {
    display: flex;
    border-radius: 0px;
  }
`;
export const Container = styled('div')`
  flex: 1;
  display: flex;
  padding: 0 !important;
  min-width: 0;
  box-shadow: ${boxShadow1};
  transition: box-shadow 0.25s;
  border-radius: 10px;
  flex-direction: column;
  background-color: var(--exact-white);
  @media only screen and (max-width: 600px) {
    display: flex;
    border-radius: 0px;
  }
`;

export const ModalBody = styled('div')`
  width: 100%;
  flex: 1 1 auto;
  height: calc(100% - 70px);
  @media only screen and (max-width: 480px) {
    margin: 0px;
  }
  @media only screen and (max-width: 600px) {
    overflow: auto;
  }
`;

export const DocumentModalContainer = styled.div`
  height: 100%;
  max-height: calc(100% - 2rem);
  display: block;
  flex-flow: column;
  overflow: hidden;
  z-index: 1319;
  opacity: 1;
  transform: scaleX(1);
  top: 10%;
  margin: 1rem;
  border-radius: 1rem;
  background-color: var(--exact-white);
  box-shadow: ${boxShadow1};
`;

export const DocumentViewHeader = styled.h3`
  height: 100%;
  font-size: 1.1rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  padding-inline-start: 0.5rem;
`;

export const LoadingContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const LoadingProgress = styled.div`
  display: flex;
  flex-direction: column;
  width: 14rem;
  font-weight: bold;
  font-size: 1rem;
  padding: 1rem 0;
  text-align: center;
  gap: 0.5rem;
`;
